// src/theme.ts
export const theme = {
  colors: {
    textColor: '#262626 ',
    mainColor: '#238C64',
    hoverColor: '#1E7252',
    subColor: '#91C6B2',
    subHoverColor: '#80B09E',
    sub2Color: '#A7A29F',
    sub2HoverColor: '#837D79',
    sub3Color: '#D3E8E0',
    sub3HoverColor: '#B0C5BD',
    sub4Color: '#4D4D4D',
    sub4HoverColor: '#363636',
    activeColor: '#54C79B',
    whiteColor: '#fff',
    blackColor: '#000',
    grayColor: '#DEDEDE',
    grayHoverColor: '#A6A6A6',
    redColor: '#E57B7B',
    redHoverColor: '#B96363',
    inputBG: '#F4F9F7',
    inputLine: '#E9F4F0',
    bgColor: '#F6F6F6',
    silverColor: '#EDEDED',
    silverColor2: '#E9E9E9',
    borderColor: '#A6C3B8',
    brownColor: '#594F48',
  },
};
